// JsFromRoutes CacheKey d5c31fb998e14bd09af73dfee5d365d5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  redirectFromShortUrl: /* #__PURE__ */ definePathHelper('get', '/c/:external_id(/:click_code)'),
  updateInvitations: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:id/invitations'),
  updateReminders: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:id/reminders'),
  updateGiftRecipients: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:id/gift_recipients'),
  createGiftRecipientContact: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:id/gift_recipient_contact'),
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/events'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events'),
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/events/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/consumer/calendar/events/:id'),
}
